/* eslint-disable no-unused-expressions */
import React from 'react'
import client from 'webpack-theme-color-replacer/client'
import { container } from '@landrover/business/index'
import { setCompanyInfo, setShowGanderce } from '@stores/actions/users'
import { Toast } from '@ifchange-eui-mobile/eui-mobile'
import Icon from '@components/Icon'
import { getCookie, setCookie } from './cookies'

export default () => {
  // eslint-disable-next-line no-underscore-dangle
  window.__theme_COLOR_cfg = {
    url: 'static/css/theme-colors.css',
    colors: ['#D0121B', '#2369e5']
  }
  container.saasService
    .getClientInfo()
    .then(({ cow_setting, company_info }) => {
      window.store && window.store.dispatch(setCompanyInfo({ cow_setting, company_info }))
      // 收藏提示，一天为用户弹一次
      // removeCookie('collect')
      if (!getCookie('collect')) {
        window.store && window.store.dispatch(setShowGanderce(true))
        setCookie('collect', true)
      }

      // eslint-disable-next-line no-unused-vars
      const newColor = cow_setting.theme_color
      const options = {
        newColors: newColor ? newColor.split(',') : [],
        changeUrl(cssUrl) {
          return `/${cssUrl}`
        }
      }
      client.changer.changeColor(options, Promise).then(() => {
        console.log('')
      })
    })
    .catch(err => {
      if (+err.err_no === 250011) {
        if (window.location.pathname === '/noFound') {
          return
        }
        window.location.replace('/noFound')
        return
      }
      if (err.err_msg) {
        Toast.warning({
          content: err.err_msg,
          icon: <Icon type="warning" size={34} />,
          duration: 1
        })
      }
    })
}
